export const fileTypes = ['png', 'svg', 'pdf', 'eps'] as const

export const fileTypeSelectOptions = fileTypes.map(type => ({ label: type, value: type }))

export const integrationName = 'QRCode Monkey Studio' as const

export const qrCodeTypes = {
  classic: {
    label: 'Classic',
    value: 'classic',
  },
  transparent: {
    label: 'Transparent',
    value: 'transparent',
  },
} as const

export const configOptions = {
  body: 'body',
  eye: 'eye',
  eyeBall: 'eyeBall',
  erf1: 'erf1',
  erf2: 'erf2',
  erf3: 'erf3',
  brf1: 'brf1',
  brf2: 'brf2',
  brf3: 'brf3',
  bodyColor: 'bodyColor',
  bgColor: 'bgColor',
  eye1Color: 'eye1Color',
  eye2Color: 'eye2Color',
  eye3Color: 'eye3Color',
  eyeBall1Color: 'eyeBall1Color',
  eyeBall2Color: 'eyeBall2Color',
  eyeBall3Color: 'eyeBall3Color',
  gradientColor1: 'gradientColor1',
  gradientColor2: 'gradientColor2',
  gradientType: 'gradientType',
  gradientOnEyes: 'gradientOnEyes',
  logo: 'logo',
} as const

export const qrCodeCustomizationOptions = {
  qrCodeType: 'qr_code_monkey_type',
  qrCodeUseShortened: 'qr_code_monkey_use_shortened',
  qrCodeDontRegenerate: 'qr_code_monkey_dont_regenerate',
  qrCodeSize: 'qr_code_monkey_size',
  qrCodeFileType: 'qr_code_monkey_file_type',
  qrCodeConfig: 'qr_code_monkey_config',
  qrCodeBackground: 'qr_code_monkey_background',
  qrCodeXOffset: 'qr_code_monkey_x_offset',
  qrCodeYOffset: 'qr_code_monkey_y_offset',
} as const
